import { Button, Link } from '@chakra-ui/react';

export const Form = () => {
	return (
		<Link href="https://hashup.it/#newsletter">
			<Button variant="sharp">Newsletter Signup</Button>
		</Link>
	);
};
